import { useState, useRef, useCallback } from "react";
import { Globe } from "lucide-react";
import { useClickOutside } from "@/hooks/use-click-outside";
import LangDropdown from "@/components/sections/header/LangDropdown";

/**
 * Mobile-only compact language switcher.
 * Shows the active language code as a small pill with a globe icon;
 * tapping opens a dropdown with all language options.
 */
export default function MobileLangSwitcher({ lang, setLang }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const close = useCallback(() => setOpen(false), [setOpen]);
  useClickOutside(wrapRef, open, close);

  const choose = (code) => {
    setLang(code);
    close();
  };

  return (
    <div className="relative sm:hidden" ref={wrapRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="mobile-lang-toggle"
        aria-label="Language / Nyelv"
        className="flex items-center gap-1.5 px-3.5 h-11 rounded-full bg-[var(--bg)] border border-[var(--border)] text-[var(--heading)] text-xs font-bold tracking-wider uppercase"
      >
        <Globe className="w-3.5 h-3.5 text-[var(--primary)]" strokeWidth={2.2} />
        {lang}
      </button>
      {open && <LangDropdown lang={lang} onPick={choose} />}
    </div>
  );
}
